import { errorHandler } from "@/services/toastHandler";

export default {
  namespaced: true,

  state: {
    loading: false,
    saving: false,
  },

  mutations: {
    SET_LOADING: (s, v) => (s.loading = v),
    SET_SAVING: (s, v) => (s.saving = v),
  },

  actions: {
    async getSubscription({ commit }, userId) {
      commit("SET_LOADING", true);
      try {
        const { data: res } = await this.$api.get(
          `/v1/portal/users/${userId}/customer-io/subscription`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateSubscription({ commit }, { userId, payload }) {
      commit("SET_SAVING", true);
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/users/${userId}/customer-io/subscription`,
          payload
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_SAVING", false);
      }
    },
  },
};
